import React from 'react';

interface TooltipProps {
    id: string;
    title: string;
    children?: React.ReactNode;
}

const Tooltip: React.FC<TooltipProps> = ({ id, title, children }) => {
    return (
        <div className="info-tooltip">
            <button
                type="button"
                className="info-tooltip-trigger"
                aria-describedby={id}
            >
                <span className="visually-hidden">{title}</span>
                <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                >
                    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.6" />
                    <path
                        d="M12 11.5V17"
                        stroke="currentColor"
                        strokeWidth="1.6"
                        strokeLinecap="round"
                    />
                    <circle cx="12" cy="8" r="1.2" fill="currentColor" />
                </svg>
            </button>
            <div className="info-tooltip-panel" role="tooltip" id={id}>
                <p className="info-tooltip-title mb-1">{title}</p>
                <div className="info-tooltip-content mb-0">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default Tooltip;
